export default function keyValueArrayToObject<T>(array: Array<any>) {
    const flatObject: { [key: string]: T } = {};
    const isArray = Array.isArray(array);
    if (!isArray) return {};
    array.forEach((row) => {
        try {
            flatObject[row[0]] = JSON.parse(row[1]);
        } catch (e) {
            flatObject[row[0]] = row[1];
        }
    });
    return flatObject;
  }

